import { render, staticRenderFns } from "./localstore.vue?vue&type=template&id=ea798934&scoped=true&"
import script from "./localstore.vue?vue&type=script&lang=js&"
export * from "./localstore.vue?vue&type=script&lang=js&"
import style0 from "./localstore.vue?vue&type=style&index=0&id=ea798934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea798934",
  null
  
)

export default component.exports